module.exports = __webpack_public_path__ + "media/images/tmp/accessories-716dfbd0ba192278f1283f4e4e8ba487.png";